export default "__VITE_ASSET__36a35f13__"